export enum Reasons {
  VENTE = 0,
  LOCATION = 1,
  RENOVATION = 2,
  CONTROLE = 3
}
